import {
  Component,
  OnInit,
  style,
  trigger,
  animate,
  transition,
} from "@angular/core";
import { ProjectsService } from "./projects.service";
import { projectList } from "../../admin/admin.interface";
import { Router } from "@angular/router";
import { MatSnackBar } from "@angular/material";
import { DeletePopUpComponent } from "../../common/delete-pop-up/delete-pop-up.component";
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from "@angular/material";
import { IMyOptions, IMyDateModel } from "mydatepicker";
import { DatePipe } from "@angular/common";
import { SessionStorage } from "ngx-webstorage";

@Component({
  selector: "app-projects",
  templateUrl: "./projects.component.html",
  styleUrls: ["./projects.component.css"],
  animations: [
    trigger("enterAnimation", [
      transition(":enter", [
        style({ opacity: 0 }),
        animate("500ms ease-in", style({ opacity: 1 })),
      ]),
    ]),
  ],
})
export class ProjectsComponent implements OnInit {
  @SessionStorage() public user;
  @SessionStorage() public config;

  public projectlistarr: projectList[] = [];
  public projectlistoriginalarr: projectList[] = [];
  public projectSearch: string;
  public pageNumber: number = 1;
  public totalElements: any = 0;
  public myDatePickerOptions: IMyOptions;
  public myDatePickerEndOptions: IMyOptions;
  public userObj;
  public searchProject: string = "";
  public userfilterproject: any = { projectname: "" };
  public startDate: any = "";
  public endDate: any = "";
  public startDatePicker: any = "";
  public endDatePicker: any = "";
  empOpen: any;

  constructor(
    public projectService: ProjectsService,
    public router: Router,
    public snackBar: MatSnackBar,
    public dialog: MatDialog,
    private datePipe: DatePipe
  ) {
    const date: Date = new Date();
    date.setDate(date.getDate() + 1);
    this.myDatePickerOptions = {
      dateFormat: "dd-mm-yyyy",
      markCurrentDay: true,
      openSelectorTopOfInput: false,
      showSelectorArrow: false,
      editableDateField: false,
      showClearDateBtn: true,
      disableSince: {
        year: date.getFullYear(),
        month: date.getMonth() + 1,
        day: date.getDate(),
      },
    };

    this.myDatePickerEndOptions = {
      dateFormat: "dd-mm-yyyy",
      markCurrentDay: true,
      openSelectorTopOfInput: false,
      showSelectorArrow: false,
      editableDateField: false,
      showClearDateBtn: true,
      inline: false,
      disableSince: {
        year: date.getFullYear(),
        month: date.getMonth() + 1,
        day: date.getDate(),
      },
    };
  }

  ngOnInit() {
    this.userObj = {
      Empno: this.user.Empno,
      Empname: this.user.Empname,
      EmailID: this.user.EmailID,
      Role: this.user.Role,
    };
    // this.navigations = [
    //   { title: 'Dashboard', link: '/admin/dashboard' },
    //   { title: 'Tasks', link: '/admin/tasks' },
    //   { title: 'Employees', link: '/admin/employees' },
    //   { title: 'Project', link: '/admin/project' },
    // ];

    if (
      this.config.businessUnit === "ipdo" ||
      this.config.businessUnit === "biologics" ||
      this.config.businessUnit === "chinateam" ||
      this.config.businessUnit === "aps"
    ) {
      this.getIPDOProjectLists();
    } else {
      this.getProjectLists();
    }
  }

  /**function to get projects list */
  getProjectLists() {
    this.projectlistarr = [];
    this.projectlistoriginalarr = [];
    this.projectService.getProjectList(this.pageNumber).subscribe((data) => {
      this.totalElements = data.payload.totalProjects;
      if (data.payload.rmprojectList) {
        data.payload.rmprojectList.forEach((value) => {
          this.projectlistarr.push(value);
          this.projectlistoriginalarr.push(value);
        });
      }
    });
  }

  /**function to get ipdo project list */
  getIPDOProjectLists() {
    this.projectlistarr = [];
    this.projectlistoriginalarr = [];
    this.projectService
      .getIPDOProjectList(this.startDate, this.endDate)
      .subscribe((data) => {
        this.totalElements = data.payload.totalProjects;
        if (data.payload.rmprojectList) {
          data.payload.rmprojectList.forEach((value) => {
            this.projectlistarr.push(value);
            this.projectlistoriginalarr.push(value);
          });
        }
      });
  }

  /**function to add project */
  addProject() {
    this.router.navigate(["/admin/project/add-project"]);
  }

  /**function to delete project */
  deleteProject(project, flag) {
    if (!flag) {
      if (this.dialog.openDialogs.length === 0) {
        let dialogRef = this.dialog.open(DeletePopUpComponent);
        dialogRef.afterClosed().subscribe((result) => {
          if (result == true) {
            let data = {
              userObj: this.userObj,
            };
            this.projectService
              .deleteProject(project, data)
              .subscribe((response) => {
                this.snackBar.open("Project Deleted Successfully", "OK", {
                  duration: 3000,
                });
                this.getProjectLists();
              });
          }
        });
      }
    }
  }

  /**function to update project */
  updateProject(i) {
    let count = 0;
    this.projectlistarr.forEach((element) => {
      if (element.editMode == true) {
        count++;
      }
    });
    if (count == 0) {
      let startDate = this.projectlistarr[i].startDate.split("-");
      this.myDatePickerEndOptions.disableUntil = {
        year: parseInt(startDate[0]),
        month: parseInt(startDate[1]),
        day: parseInt(startDate[2]),
      };
      this.projectlistarr[i].editMode = !this.projectlistarr[i].editMode;
    }
  }

  /**function to show project detail*/
  showProjectDetail(project) {
    if (project.arrowclicked === true) {
      project.arrowclicked = false;
    } else {
      this.projectlistarr.forEach((element) => {
        element.arrowclicked = false;
      });
      project.arrowclicked = true;
    }
  }

  /**function to update project detail */
  updatedetails(i) {
    if (
      this.projectlistarr[i].Project != "" &&
      this.projectlistarr[i].originalstartDateobj != null
    ) {
      this.projectlistarr[i].editMode = false;
      let data = {
        Project: this.projectlistoriginalarr[i].Project,
        updateItems: {
          Project: this.projectlistarr[i].Project,
          startDate: this.projectlistarr[i].originalstartDateobj.formatted,
          endDate: this.projectlistarr[i].originalendDateobj.formatted,
        },
        userObj: this.userObj,
      };
      this.projectService.updateProject(data).subscribe((response) => {
        this.snackBar.open("Project Updated Successfully", "OK", {
          duration: 3000,
          extraClasses: ["textCenter"],
        });
        this.getProjectLists();
      });
    } else {
      this.snackBar.open("Please fill all the field", "OK", {
        duration: 3000,
        extraClasses: ["textCenter"],
      });
      this.getProjectLists();
    }
  }

  /**function to search  project search data*/
  checkSearchData(searchData) {
    if (!searchData) {
      this.applySearch("");
    }
  }

  /**function to search project */
  applySearch(searchData) {
    this.userfilterproject.projectname = searchData.trim();
  }

  /**function to search project */
  triggerChange(data: any) {
    this.pageNumber = data;
    this.getProjectLists();
  }

  /**function to set start date */
  startDateChange(event, projectInfo) {
    this.myDatePickerEndOptions = JSON.parse(
      JSON.stringify(this.myDatePickerEndOptions)
    );
    this.myDatePickerEndOptions.disableUntil = event.date;
  }

  /**function to validate start date and end date */
  projectDatePicker() {
    const startDate = this.startDatePicker
      ? this.datePipe.transform(this.startDatePicker.jsdate, "yyyy-MM-dd")
      : "";
    const endDate = this.endDatePicker
      ? this.datePipe.transform(this.endDatePicker.jsdate, "yyyy-MM-dd")
      : "";
    if (startDate && endDate) {
      if (this.startDatePicker.epoc < this.endDatePicker.epoc) {
        this.startDate = startDate;
        this.endDate = endDate;
        this.projectlistarr = [];
        this.getIPDOProjectLists();
      } else {
        this.snackBar.open("Please select the valid date range", "OK", {
          duration: 3000,
        });
      }
    } else if (!startDate && !endDate) {
      this.startDate = "";
      this.endDate = "";
      this.projectlistarr = [];
      this.getIPDOProjectLists();
    } else if (!endDate) {
      this.snackBar.open("Please select the end date", "OK", {
        duration: 3000,
      });
    } else if (!startDate) {
      this.snackBar.open("Please select the start date", "OK", {
        duration: 3000,
      });
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/rm/projects/projects.component.ts